'use strict';

var $ = require('jquery');
import { partial } from 'lodash';

/** @module EventPreventer
 * @requires jquery
 * @requires lodash
 */
function EventPreventer() {
	var _prevent = function(ev) { ev.preventDefault(); };

	var _bind = function(root) {
		$('iframe, embed, video').css({ 'pointer-events': 'none' });
		$(root).off('.prevent')
			.on('click.prevent', 'form input[type=submit]', _prevent)
			.on('click.prevent', 'a[href]', _prevent)
			.on('submit.prevent', 'form[action]', _prevent);
	};

	var _unbind = function(root) {
		$('iframe, embed, video', root).css({ 'pointer-events': 'inherit' });
		$(root).off('.prevent');
	};

	var _bindGlobal = function() {
		$(document).on('keydown.prevent', function(ev) {
			if (ev.keyCode === 9) ev.preventDefault();
		});
	};

	var _unbindGlobal = function() {
		$(document).off('keydown.prevent');
	};

	this.setup = function(root) {
		this.destroy(root);
		this.observer = new MutationObserver(partial(_bind, root));
		this.observer.observe(root, { childList: true });

		_bindGlobal();
	};

	this.destroy = function(root) {
		if(!this.observer) return;

		this.observer.disconnect();
		this.observer = null;

		_unbind(root);
		_unbindGlobal();
	};
}

module.exports = EventPreventer;
